import { useEffect, useState } from 'react'
import { ListPageHeader } from '@/components/common/ListPageHeader'
import { useStatusTracks } from '@/features/contract/statuses/hooks'
import { TrackListPanel } from './components/TrackListPanel'
import { TrackEditorPanel } from './components/TrackEditorPanel'

export function StatusTracksAdminPage() {
  const tracks = useStatusTracks(false)
  const [selectedId, setSelectedId] = useState<number | null>(null)

  useEffect(() => {
    if (!tracks.data) return
    if (selectedId && tracks.data.some(t => t.id === selectedId)) return
    setSelectedId(tracks.data[0]?.id ?? null)
  }, [tracks.data, selectedId])

  const selected = tracks.data?.find(t => t.id === selectedId) ?? null

  return (
    <div className="flex flex-col w-full h-full">
      <ListPageHeader
        title="Tory statusów"
        subtitle={`Każdy tor (np. "Kredyty", "Logistyka") ma swoje wartości i jest niezależny od głównego etapu umowy.`}
      />
      <div className="flex flex-1 overflow-hidden">
        <TrackListPanel
          tracks={tracks.data ?? []}
          selectedId={selectedId}
          onSelect={setSelectedId}
        />
        {selected ? (
          <TrackEditorPanel track={selected} />
        ) : (
          <div className="flex-1 flex items-center justify-center text-sm text-slate-500">
            Wybierz tor lub dodaj nowy.
          </div>
        )}
      </div>
    </div>
  )
}
